import api from './api';

// White-label branding for the client portal, resolved by the cabinet domain
// the portal is opened on. Public endpoint — works before login.
export const portalHost = () => window.location.hostname;

export const fetchPortalBranding = async () => {
  try {
    const { data } = await api.get('/portal/branding', { params: { host: portalHost() } });
    return { brandName: data?.brandName || null, hasLogo: !!data?.hasLogo };
  } catch {
    return { brandName: null, hasLogo: false };
  }
};

export const portalLogoUrl = () =>
  `${api.defaults.baseURL}/portal/branding/logo?host=${encodeURIComponent(portalHost())}`;
